/**
 * @description Marketing common functions and attributes
 * Add the common redundant code in this mixin
 */
export default {
  name: 'CommonMixin',
  methods: {
    /**
     * @description only truncate Price(USD) value upto two decimal places
     * don't rounded off as per requirement for Catalog UI only
     * Example:
     * Input 1.99998 UI Out 1.99
     * Input 12343.456 UI output 12,343.45
     * Input 101 UI Out 101.00
     * Input 12.987 UI output 12.98
     */
    currencyFormat (price) {
      if (price && price !== 0) {
        const splittedValues = String(price).split('.')
        let decimalValue = splittedValues.length > 1 ? splittedValues[1] : ''
        decimalValue = decimalValue.concat('00').substr(0, 2)
        return `${Number(splittedValues[0]).toLocaleString()}.${decimalValue}`
      } else {
        return '0.00'
      }
    },
  },
}
